export const cityList = [
    {
        "first": "A",
        "list": [
            {
                "cityName": "阿坝藏族羌族自治州",
                "cityMdCode": 513200,
                "cityAreaMdCode": null,
                "cityPinyin": "ABAZANGZUQIANGZUZIZHIZHOU",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "阿克苏地区",
                "cityMdCode": 652900,
                "cityAreaMdCode": null,
                "cityPinyin": "AKESUDIQU",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "阿拉尔市",
                "cityMdCode": 659002,
                "cityAreaMdCode": null,
                "cityPinyin": "ALAERSHI",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "阿拉善盟",
                "cityMdCode": 152900,
                "cityAreaMdCode": null,
                "cityPinyin": "ALASHANMENG",
                "provinceMdCode": 150000,
                "provinceName": "内蒙古自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "阿勒泰地区",
                "cityMdCode": 654300,
                "cityAreaMdCode": null,
                "cityPinyin": "ALETAIDIQU",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "安康市",
                "cityMdCode": 610900,
                "cityAreaMdCode": null,
                "cityPinyin": "ANKANGSHI",
                "provinceMdCode": 610000,
                "provinceName": "陕西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "安庆市",
                "cityMdCode": 340800,
                "cityAreaMdCode": null,
                "cityPinyin": "ANQINGSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "鞍山市",
                "cityMdCode": 210300,
                "cityAreaMdCode": null,
                "cityPinyin": "ANSHANSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "安顺市",
                "cityMdCode": 520400,
                "cityAreaMdCode": null,
                "cityPinyin": "ANSHUNSHI",
                "provinceMdCode": 520000,
                "provinceName": "贵州省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "安阳市",
                "cityMdCode": 410500,
                "cityAreaMdCode": null,
                "cityPinyin": "ANYANGSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "B",
        "list": [
            {
                "cityName": "白城市",
                "cityMdCode": 220800,
                "cityAreaMdCode": null,
                "cityPinyin": "BAICHENGSHI",
                "provinceMdCode": 220000,
                "provinceName": "吉林省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "百色市",
                "cityMdCode": 451000,
                "cityAreaMdCode": null,
                "cityPinyin": "BAISESHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "白沙黎族自治县",
                "cityMdCode": 469025,
                "cityAreaMdCode": null,
                "cityPinyin": "BAISHALIZUZIZHIXIAN",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "白山市",
                "cityMdCode": 220600,
                "cityAreaMdCode": null,
                "cityPinyin": "BAISHANSHI",
                "provinceMdCode": 220000,
                "provinceName": "吉林省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "白银市",
                "cityMdCode": 620400,
                "cityAreaMdCode": null,
                "cityPinyin": "BAIYINSHI",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "蚌埠市",
                "cityMdCode": 340300,
                "cityAreaMdCode": null,
                "cityPinyin": "BANGBUSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "保定市",
                "cityMdCode": 130600,
                "cityAreaMdCode": null,
                "cityPinyin": "BAODINGSHI",
                "provinceMdCode": 130000,
                "provinceName": "河北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "宝鸡市",
                "cityMdCode": 610300,
                "cityAreaMdCode": null,
                "cityPinyin": "BAOJISHI",
                "provinceMdCode": 610000,
                "provinceName": "陕西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "保山市",
                "cityMdCode": 530500,
                "cityAreaMdCode": null,
                "cityPinyin": "BAOSHANSHI",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "包头市",
                "cityMdCode": 150200,
                "cityAreaMdCode": null,
                "cityPinyin": "BAOTOUSHI",
                "provinceMdCode": 150000,
                "provinceName": "内蒙古自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "巴彦淖尔市",
                "cityMdCode": 150800,
                "cityAreaMdCode": null,
                "cityPinyin": "BAYANNAOERSHI",
                "provinceMdCode": 150000,
                "provinceName": "内蒙古自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "巴音郭楞蒙古自治州",
                "cityMdCode": 652800,
                "cityAreaMdCode": null,
                "cityPinyin": "BAYINGUOLENGMENGGUZIZHIZHOU",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "巴中市",
                "cityMdCode": 511900,
                "cityAreaMdCode": null,
                "cityPinyin": "BAZHONGSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "北海市",
                "cityMdCode": 450500,
                "cityAreaMdCode": null,
                "cityPinyin": "BEIHAISHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "北京市",
                "cityMdCode": 110100,
                "cityAreaMdCode": null,
                "cityPinyin": "BEIJINGSHI",
                "provinceMdCode": 110000,
                "provinceName": "北京市",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "北屯市",
                "cityMdCode": 659005,
                "cityAreaMdCode": null,
                "cityPinyin": "BEITUNSHI",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "本溪市",
                "cityMdCode": 210500,
                "cityAreaMdCode": null,
                "cityPinyin": "BENXISHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "毕节市",
                "cityMdCode": 520500,
                "cityAreaMdCode": null,
                "cityPinyin": "BIJIESHI",
                "provinceMdCode": 520000,
                "provinceName": "贵州省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "滨州市",
                "cityMdCode": 371600,
                "cityAreaMdCode": null,
                "cityPinyin": "BINZHOUSHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "博尔塔拉蒙古自治州",
                "cityMdCode": 652700,
                "cityAreaMdCode": null,
                "cityPinyin": "BOERTALAMENGGUZIZHIZHOU",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "亳州市",
                "cityMdCode": 341600,
                "cityAreaMdCode": null,
                "cityPinyin": "BOZHOUSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "C",
        "list": [
            {
                "cityName": "沧州市",
                "cityMdCode": 130900,
                "cityAreaMdCode": null,
                "cityPinyin": "CANGZHOUSHI",
                "provinceMdCode": 130000,
                "provinceName": "河北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "长春市",
                "cityMdCode": 220100,
                "cityAreaMdCode": null,
                "cityPinyin": "CHANGCHUNSHI",
                "provinceMdCode": 220000,
                "provinceName": "吉林省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "常德市",
                "cityMdCode": 430700,
                "cityAreaMdCode": null,
                "cityPinyin": "CHANGDESHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "昌江黎族自治县",
                "cityMdCode": 469026,
                "cityAreaMdCode": null,
                "cityPinyin": "CHANGJIANGLIZUZIZHIXIAN",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "昌吉回族自治州",
                "cityMdCode": 652300,
                "cityAreaMdCode": null,
                "cityPinyin": "CHANGJIHUIZUZIZHIZHOU",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "长沙市",
                "cityMdCode": 430100,
                "cityAreaMdCode": null,
                "cityPinyin": "CHANGSHASHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "长治市",
                "cityMdCode": 140400,
                "cityAreaMdCode": null,
                "cityPinyin": "CHANGZHISHI",
                "provinceMdCode": 140000,
                "provinceName": "山西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "常州市",
                "cityMdCode": 320400,
                "cityAreaMdCode": null,
                "cityPinyin": "CHANGZHOUSHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "朝阳市",
                "cityMdCode": 211300,
                "cityAreaMdCode": null,
                "cityPinyin": "CHAOYANGSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "潮州市",
                "cityMdCode": 445100,
                "cityAreaMdCode": null,
                "cityPinyin": "CHAOZHOUSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "承德市",
                "cityMdCode": 130800,
                "cityAreaMdCode": null,
                "cityPinyin": "CHENGDESHI",
                "provinceMdCode": 130000,
                "provinceName": "河北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "成都市",
                "cityMdCode": 510100,
                "cityAreaMdCode": null,
                "cityPinyin": "CHENGDOUSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "澄迈县",
                "cityMdCode": 469023,
                "cityAreaMdCode": null,
                "cityPinyin": "CHENGMAIXIAN",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "郴州市",
                "cityMdCode": 431000,
                "cityAreaMdCode": null,
                "cityPinyin": "CHENZHOUSHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "赤峰市",
                "cityMdCode": 150400,
                "cityAreaMdCode": null,
                "cityPinyin": "CHIFENGSHI",
                "provinceMdCode": 150000,
                "provinceName": "内蒙古自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "池州市",
                "cityMdCode": 341700,
                "cityAreaMdCode": null,
                "cityPinyin": "CHIZHOUSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "重庆市",
                "cityMdCode": 500300,
                "cityAreaMdCode": null,
                "cityPinyin": "CHONGQINGSHI",
                "provinceMdCode": 500000,
                "provinceName": "重庆市",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "崇左市",
                "cityMdCode": 451400,
                "cityAreaMdCode": null,
                "cityPinyin": "CHONGZUOSHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "楚雄彝族自治州",
                "cityMdCode": 532300,
                "cityAreaMdCode": null,
                "cityPinyin": "CHUXIONGYIZUZIZHIZHOU",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "滁州市",
                "cityMdCode": 341100,
                "cityAreaMdCode": null,
                "cityPinyin": "CHUZHOUSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "D",
        "list": [
            {
                "cityName": "大连市",
                "cityMdCode": 210200,
                "cityAreaMdCode": null,
                "cityPinyin": "DALIANSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "大理白族自治州",
                "cityMdCode": 532900,
                "cityAreaMdCode": null,
                "cityPinyin": "DALIBAIZUZIZHIZHOU",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "丹东市",
                "cityMdCode": 210600,
                "cityAreaMdCode": null,
                "cityPinyin": "DANDONGSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "儋州市",
                "cityMdCode": 460400,
                "cityAreaMdCode": null,
                "cityPinyin": "DANZHOUSHI",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "大庆市",
                "cityMdCode": 230600,
                "cityAreaMdCode": null,
                "cityPinyin": "DAQINGSHI",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "大同市",
                "cityMdCode": 140200,
                "cityAreaMdCode": null,
                "cityPinyin": "DATONGSHI",
                "provinceMdCode": 140000,
                "provinceName": "山西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "大兴安岭地区",
                "cityMdCode": 232700,
                "cityAreaMdCode": null,
                "cityPinyin": "DAXINGANLINGDIQU",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "达州市",
                "cityMdCode": 511700,
                "cityAreaMdCode": null,
                "cityPinyin": "DAZHOUSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "德宏傣族景颇族自治州",
                "cityMdCode": 533100,
                "cityAreaMdCode": null,
                "cityPinyin": "DEHONGDAIZUJINGPOZUZIZHIZHOU",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "德阳市",
                "cityMdCode": 510600,
                "cityAreaMdCode": null,
                "cityPinyin": "DEYANGSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "德州市",
                "cityMdCode": 371400,
                "cityAreaMdCode": null,
                "cityPinyin": "DEZHOUSHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "定安县",
                "cityMdCode": 469021,
                "cityAreaMdCode": null,
                "cityPinyin": "DINGANXIAN",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "定西市",
                "cityMdCode": 621100,
                "cityAreaMdCode": null,
                "cityPinyin": "DINGXISHI",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "迪庆藏族自治州",
                "cityMdCode": 533400,
                "cityAreaMdCode": null,
                "cityPinyin": "DIQINGZANGZUZIZHIZHOU",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "东方市",
                "cityMdCode": 469007,
                "cityAreaMdCode": null,
                "cityPinyin": "DONGFANGSHI",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "东莞市",
                "cityMdCode": 441900,
                "cityAreaMdCode": null,
                "cityPinyin": "DONGGUANSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "东营市",
                "cityMdCode": 370500,
                "cityAreaMdCode": null,
                "cityPinyin": "DONGYINGSHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "E",
        "list": [
            {
                "cityName": "鄂尔多斯市",
                "cityMdCode": 150600,
                "cityAreaMdCode": null,
                "cityPinyin": "EERDUOSISHI",
                "provinceMdCode": 150000,
                "provinceName": "内蒙古自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "恩施土家族苗族自治州",
                "cityMdCode": 422800,
                "cityAreaMdCode": null,
                "cityPinyin": "ENSHITUJIAZUMIAOZUZIZHIZHOU",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "鄂州市",
                "cityMdCode": 420700,
                "cityAreaMdCode": null,
                "cityPinyin": "EZHOUSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "F",
        "list": [
            {
                "cityName": "防城港市",
                "cityMdCode": 450600,
                "cityAreaMdCode": null,
                "cityPinyin": "FANGCHENGGANGSHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "佛山市",
                "cityMdCode": 440600,
                "cityAreaMdCode": null,
                "cityPinyin": "FOSHANSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "抚顺市",
                "cityMdCode": 210400,
                "cityAreaMdCode": null,
                "cityPinyin": "FUSHUNSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "阜新市",
                "cityMdCode": 210900,
                "cityAreaMdCode": null,
                "cityPinyin": "FUXINSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "阜阳市",
                "cityMdCode": 341200,
                "cityAreaMdCode": null,
                "cityPinyin": "FUYANGSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "福州市",
                "cityMdCode": 350100,
                "cityAreaMdCode": null,
                "cityPinyin": "FUZHOUSHI",
                "provinceMdCode": 350000,
                "provinceName": "福建省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "抚州市",
                "cityMdCode": 361000,
                "cityAreaMdCode": null,
                "cityPinyin": "FUZHOUSHI",
                "provinceMdCode": 360000,
                "provinceName": "江西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "G",
        "list": [
            {
                "cityName": "赣州市",
                "cityMdCode": 360700,
                "cityAreaMdCode": null,
                "cityPinyin": "GANZHOUSHI",
                "provinceMdCode": 360000,
                "provinceName": "江西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "广安市",
                "cityMdCode": 511600,
                "cityAreaMdCode": null,
                "cityPinyin": "GUANGANSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "广元市",
                "cityMdCode": 510800,
                "cityAreaMdCode": null,
                "cityPinyin": "GUANGYUANSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "广州市",
                "cityMdCode": 440100,
                "cityAreaMdCode": null,
                "cityPinyin": "GUANGZHOUSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "贵港市",
                "cityMdCode": 450800,
                "cityAreaMdCode": null,
                "cityPinyin": "GUIGANGSHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "桂林市",
                "cityMdCode": 450300,
                "cityAreaMdCode": null,
                "cityPinyin": "GUILINSHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "贵阳市",
                "cityMdCode": 520100,
                "cityAreaMdCode": null,
                "cityPinyin": "GUIYANGSHI",
                "provinceMdCode": 520000,
                "provinceName": "贵州省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "固原市",
                "cityMdCode": 640400,
                "cityAreaMdCode": null,
                "cityPinyin": "GUYUANSHI",
                "provinceMdCode": 640000,
                "provinceName": "宁夏回族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "H",
        "list": [
            {
                "cityName": "哈尔滨市",
                "cityMdCode": 230100,
                "cityAreaMdCode": null,
                "cityPinyin": "HAERBINSHI",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "海东市",
                "cityMdCode": 630200,
                "cityAreaMdCode": null,
                "cityPinyin": "HAIDONGSHI",
                "provinceMdCode": 630000,
                "provinceName": "青海省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "海口市",
                "cityMdCode": 460100,
                "cityAreaMdCode": null,
                "cityPinyin": "HAIKOUSHI",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "哈密市",
                "cityMdCode": 650500,
                "cityAreaMdCode": null,
                "cityPinyin": "HAMISHI",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "邯郸市",
                "cityMdCode": 130400,
                "cityAreaMdCode": null,
                "cityPinyin": "HANDANSHI",
                "provinceMdCode": 130000,
                "provinceName": "河北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "杭州市",
                "cityMdCode": 330100,
                "cityAreaMdCode": null,
                "cityPinyin": "HANGZHOUSHI",
                "provinceMdCode": 330000,
                "provinceName": "浙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "汉中市",
                "cityMdCode": 610700,
                "cityAreaMdCode": null,
                "cityPinyin": "HANZHONGSHI",
                "provinceMdCode": 610000,
                "provinceName": "陕西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "鹤壁市",
                "cityMdCode": 410600,
                "cityAreaMdCode": null,
                "cityPinyin": "HEBISHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "河池市",
                "cityMdCode": 451200,
                "cityAreaMdCode": null,
                "cityPinyin": "HECHISHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "合肥市",
                "cityMdCode": 340100,
                "cityAreaMdCode": null,
                "cityPinyin": "HEFEISHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "鹤岗市",
                "cityMdCode": 230400,
                "cityAreaMdCode": null,
                "cityPinyin": "HEGANGSHI",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "黑河市",
                "cityMdCode": 231100,
                "cityAreaMdCode": null,
                "cityPinyin": "HEIHESHI",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "衡水市",
                "cityMdCode": 131100,
                "cityAreaMdCode": null,
                "cityPinyin": "HENGSHUISHI",
                "provinceMdCode": 130000,
                "provinceName": "河北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "衡阳市",
                "cityMdCode": 430400,
                "cityAreaMdCode": null,
                "cityPinyin": "HENGYANGSHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "和田地区",
                "cityMdCode": 653200,
                "cityAreaMdCode": null,
                "cityPinyin": "HETIANDIQU",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "河源市",
                "cityMdCode": 441600,
                "cityAreaMdCode": null,
                "cityPinyin": "HEYUANSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "菏泽市",
                "cityMdCode": 371700,
                "cityAreaMdCode": null,
                "cityPinyin": "HEZESHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "贺州市",
                "cityMdCode": 451100,
                "cityAreaMdCode": null,
                "cityPinyin": "HEZHOUSHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "红河哈尼族彝族自治州",
                "cityMdCode": 532500,
                "cityAreaMdCode": null,
                "cityPinyin": "HONGHEHANIZUYIZUZIZHIZHOU",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "淮安市",
                "cityMdCode": 320800,
                "cityAreaMdCode": null,
                "cityPinyin": "HUAIANSHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "淮北市",
                "cityMdCode": 340600,
                "cityAreaMdCode": null,
                "cityPinyin": "HUAIBEISHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "怀化市",
                "cityMdCode": 431200,
                "cityAreaMdCode": null,
                "cityPinyin": "HUAIHUASHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "淮南市",
                "cityMdCode": 340400,
                "cityAreaMdCode": null,
                "cityPinyin": "HUAINANSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "黄冈市",
                "cityMdCode": 421100,
                "cityAreaMdCode": null,
                "cityPinyin": "HUANGGANGSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "黄山市",
                "cityMdCode": 341000,
                "cityAreaMdCode": null,
                "cityPinyin": "HUANGSHANSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "黄石市",
                "cityMdCode": 420200,
                "cityAreaMdCode": null,
                "cityPinyin": "HUANGSHISHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "呼和浩特市",
                "cityMdCode": 150100,
                "cityAreaMdCode": null,
                "cityPinyin": "HUHEHAOTESHI",
                "provinceMdCode": 150000,
                "provinceName": "内蒙古自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "惠州市",
                "cityMdCode": 441300,
                "cityAreaMdCode": null,
                "cityPinyin": "HUIZHOUSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "葫芦岛市",
                "cityMdCode": 211400,
                "cityAreaMdCode": null,
                "cityPinyin": "HULUDAOSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "呼伦贝尔市",
                "cityMdCode": 150700,
                "cityAreaMdCode": null,
                "cityPinyin": "HULUNBEIERSHI",
                "provinceMdCode": 150000,
                "provinceName": "内蒙古自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "湖州市",
                "cityMdCode": 330500,
                "cityAreaMdCode": null,
                "cityPinyin": "HUZHOUSHI",
                "provinceMdCode": 330000,
                "provinceName": "浙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "I",
        "list": []
    },
    {
        "first": "J",
        "list": [
            {
                "cityName": "佳木斯市",
                "cityMdCode": 230800,
                "cityAreaMdCode": null,
                "cityPinyin": "JIAMUSISHI",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "江门市",
                "cityMdCode": 440700,
                "cityAreaMdCode": null,
                "cityPinyin": "JIANGMENSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "吉安市",
                "cityMdCode": 360800,
                "cityAreaMdCode": null,
                "cityPinyin": "JIANSHI",
                "provinceMdCode": 360000,
                "provinceName": "江西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "焦作市",
                "cityMdCode": 410800,
                "cityAreaMdCode": null,
                "cityPinyin": "JIAOZUOSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "嘉兴市",
                "cityMdCode": 330400,
                "cityAreaMdCode": null,
                "cityPinyin": "JIAXINGSHI",
                "provinceMdCode": 330000,
                "provinceName": "浙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "嘉峪关市",
                "cityMdCode": 620200,
                "cityAreaMdCode": null,
                "cityPinyin": "JIAYUGUANSHI",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "揭阳市",
                "cityMdCode": 445200,
                "cityAreaMdCode": null,
                "cityPinyin": "JIEYANGSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "吉林市",
                "cityMdCode": 220200,
                "cityAreaMdCode": null,
                "cityPinyin": "JILINSHI",
                "provinceMdCode": 220000,
                "provinceName": "吉林省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "济南市",
                "cityMdCode": 370100,
                "cityAreaMdCode": null,
                "cityPinyin": "JINANSHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "金昌市",
                "cityMdCode": 620300,
                "cityAreaMdCode": null,
                "cityPinyin": "JINCHANGSHI",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "晋城市",
                "cityMdCode": 140500,
                "cityAreaMdCode": null,
                "cityPinyin": "JINCHENGSHI",
                "provinceMdCode": 140000,
                "provinceName": "山西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "景德镇市",
                "cityMdCode": 360200,
                "cityAreaMdCode": null,
                "cityPinyin": "JINGDEZHENSHI",
                "provinceMdCode": 360000,
                "provinceName": "江西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "荆门市",
                "cityMdCode": 420800,
                "cityAreaMdCode": null,
                "cityPinyin": "JINGMENSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "荆州市",
                "cityMdCode": 421000,
                "cityAreaMdCode": null,
                "cityPinyin": "JINGZHOUSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "金华市",
                "cityMdCode": 330700,
                "cityAreaMdCode": null,
                "cityPinyin": "JINHUASHI",
                "provinceMdCode": 330000,
                "provinceName": "浙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "济宁市",
                "cityMdCode": 370800,
                "cityAreaMdCode": null,
                "cityPinyin": "JININGSHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "晋中市",
                "cityMdCode": 140700,
                "cityAreaMdCode": null,
                "cityPinyin": "JINZHONGSHI",
                "provinceMdCode": 140000,
                "provinceName": "山西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "锦州市",
                "cityMdCode": 210700,
                "cityAreaMdCode": null,
                "cityPinyin": "JINZHOUSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "九江市",
                "cityMdCode": 360400,
                "cityAreaMdCode": null,
                "cityPinyin": "JIUJIANGSHI",
                "provinceMdCode": 360000,
                "provinceName": "江西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "酒泉市",
                "cityMdCode": 620900,
                "cityAreaMdCode": null,
                "cityPinyin": "JIUQUANSHI",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "鸡西市",
                "cityMdCode": 230300,
                "cityAreaMdCode": null,
                "cityPinyin": "JIXISHI",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "济源市",
                "cityMdCode": 419001,
                "cityAreaMdCode": null,
                "cityPinyin": "JIYUANSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "K",
        "list": [
            {
                "cityName": "开封市",
                "cityMdCode": 410200,
                "cityAreaMdCode": null,
                "cityPinyin": "KAIFENGSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "喀什地区",
                "cityMdCode": 653100,
                "cityAreaMdCode": null,
                "cityPinyin": "KASHENDIQU",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "克拉玛依市",
                "cityMdCode": 650200,
                "cityAreaMdCode": null,
                "cityPinyin": "KELAMAYISHI",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "克孜勒苏柯尔克孜自治州",
                "cityMdCode": 653000,
                "cityAreaMdCode": null,
                "cityPinyin": "KEZILESUKEERKEZIZIZHIZHOU",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "昆明市",
                "cityMdCode": 530100,
                "cityAreaMdCode": null,
                "cityPinyin": "KUNMINGSHI",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "L",
        "list": [
            {
                "cityName": "来宾市",
                "cityMdCode": 451300,
                "cityAreaMdCode": null,
                "cityPinyin": "LAIBINSHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "廊坊市",
                "cityMdCode": 131000,
                "cityAreaMdCode": null,
                "cityPinyin": "LANGFANGSHI",
                "provinceMdCode": 130000,
                "provinceName": "河北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "兰州市",
                "cityMdCode": 620100,
                "cityAreaMdCode": null,
                "cityPinyin": "LANZHOUSHI",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "拉萨市",
                "cityMdCode": 540100,
                "cityAreaMdCode": null,
                "cityPinyin": "LASASHI",
                "provinceMdCode": 540000,
                "provinceName": "西藏自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "乐山市",
                "cityMdCode": 511100,
                "cityAreaMdCode": null,
                "cityPinyin": "LESHANSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "凉山彝族自治州",
                "cityMdCode": 513400,
                "cityAreaMdCode": null,
                "cityPinyin": "LIANGSHANYIZUZIZHIZHOU",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "连云港市",
                "cityMdCode": 320700,
                "cityAreaMdCode": null,
                "cityPinyin": "LIANYUNGANGSHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "聊城市",
                "cityMdCode": 371500,
                "cityAreaMdCode": null,
                "cityPinyin": "LIAOCHENGSHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "辽阳市",
                "cityMdCode": 211000,
                "cityAreaMdCode": null,
                "cityPinyin": "LIAOYANGSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "辽源市",
                "cityMdCode": 220400,
                "cityAreaMdCode": null,
                "cityPinyin": "LIAOYUANSHI",
                "provinceMdCode": 220000,
                "provinceName": "吉林省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "丽江市",
                "cityMdCode": 530700,
                "cityAreaMdCode": null,
                "cityPinyin": "LIJIANGSHI",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "临沧市",
                "cityMdCode": 530900,
                "cityAreaMdCode": null,
                "cityPinyin": "LINCANGSHI",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "临汾市",
                "cityMdCode": 141000,
                "cityAreaMdCode": null,
                "cityPinyin": "LINFENSHI",
                "provinceMdCode": 140000,
                "provinceName": "山西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "临高县",
                "cityMdCode": 469024,
                "cityAreaMdCode": null,
                "cityPinyin": "LINGAOXIAN",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "陵水黎族自治县",
                "cityMdCode": 469028,
                "cityAreaMdCode": null,
                "cityPinyin": "LINGSHUILIZUZIZHIXIAN",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "临夏回族自治州",
                "cityMdCode": 622900,
                "cityAreaMdCode": null,
                "cityPinyin": "LINXIAHUIZUZIZHIZHOU",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "临沂市",
                "cityMdCode": 371300,
                "cityAreaMdCode": null,
                "cityPinyin": "LINYISHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "林芝市",
                "cityMdCode": 540400,
                "cityAreaMdCode": null,
                "cityPinyin": "LINZHISHI",
                "provinceMdCode": 540000,
                "provinceName": "西藏自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "丽水市",
                "cityMdCode": 331100,
                "cityAreaMdCode": null,
                "cityPinyin": "LISHUISHI",
                "provinceMdCode": 330000,
                "provinceName": "浙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "六安市",
                "cityMdCode": 341500,
                "cityAreaMdCode": null,
                "cityPinyin": "LIUANSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "六盘水市",
                "cityMdCode": 520200,
                "cityAreaMdCode": null,
                "cityPinyin": "LIUPANSHUISHI",
                "provinceMdCode": 520000,
                "provinceName": "贵州省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "柳州市",
                "cityMdCode": 450200,
                "cityAreaMdCode": null,
                "cityPinyin": "LIUZHOUSHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "陇南市",
                "cityMdCode": 621200,
                "cityAreaMdCode": null,
                "cityPinyin": "LONGNANSHI",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "龙岩市",
                "cityMdCode": 350800,
                "cityAreaMdCode": null,
                "cityPinyin": "LONGYANSHI",
                "provinceMdCode": 350000,
                "provinceName": "福建省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "娄底市",
                "cityMdCode": 431300,
                "cityAreaMdCode": null,
                "cityPinyin": "LOUDISHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "漯河市",
                "cityMdCode": 411100,
                "cityAreaMdCode": null,
                "cityPinyin": "LUOHESHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "洛阳市",
                "cityMdCode": 410300,
                "cityAreaMdCode": null,
                "cityPinyin": "LUOYANGSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "泸州市",
                "cityMdCode": 510500,
                "cityAreaMdCode": null,
                "cityPinyin": "LUZHOUSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "吕梁市",
                "cityMdCode": 141100,
                "cityAreaMdCode": null,
                "cityPinyin": "LVLIANGSHI",
                "provinceMdCode": 140000,
                "provinceName": "山西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "M",
        "list": [
            {
                "cityName": "马鞍山市",
                "cityMdCode": 340500,
                "cityAreaMdCode": null,
                "cityPinyin": "MAANSHANSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "茂名市",
                "cityMdCode": 440900,
                "cityAreaMdCode": null,
                "cityPinyin": "MAOMINGSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "眉山市",
                "cityMdCode": 511400,
                "cityAreaMdCode": null,
                "cityPinyin": "MEISHANSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "梅州市",
                "cityMdCode": 441400,
                "cityAreaMdCode": null,
                "cityPinyin": "MEIZHOUSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "绵阳市",
                "cityMdCode": 510700,
                "cityAreaMdCode": null,
                "cityPinyin": "MIANYANGSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "牡丹江市",
                "cityMdCode": 231000,
                "cityAreaMdCode": null,
                "cityPinyin": "MUDANJIANGSHI",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "N",
        "list": [
            {
                "cityName": "南昌市",
                "cityMdCode": 360100,
                "cityAreaMdCode": null,
                "cityPinyin": "NANCHANGSHI",
                "provinceMdCode": 360000,
                "provinceName": "江西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "南充市",
                "cityMdCode": 511300,
                "cityAreaMdCode": null,
                "cityPinyin": "NANCHONGSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "南京市",
                "cityMdCode": 320100,
                "cityAreaMdCode": null,
                "cityPinyin": "NANJINGSHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "南宁市",
                "cityMdCode": 450100,
                "cityAreaMdCode": null,
                "cityPinyin": "NANNINGSHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "南平市",
                "cityMdCode": 350700,
                "cityAreaMdCode": null,
                "cityPinyin": "NANPINGSHI",
                "provinceMdCode": 350000,
                "provinceName": "福建省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "南通市",
                "cityMdCode": 320600,
                "cityAreaMdCode": null,
                "cityPinyin": "NANTONGSHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "南阳市",
                "cityMdCode": 411300,
                "cityAreaMdCode": null,
                "cityPinyin": "NANYANGSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "内江市",
                "cityMdCode": 511000,
                "cityAreaMdCode": null,
                "cityPinyin": "NEIJIANGSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "那曲市",
                "cityMdCode": 540600,
                "cityAreaMdCode": null,
                "cityPinyin": "NEIQUSHI",
                "provinceMdCode": 540000,
                "provinceName": "西藏自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "宁波市",
                "cityMdCode": 330200,
                "cityAreaMdCode": null,
                "cityPinyin": "NINGBOSHI",
                "provinceMdCode": 330000,
                "provinceName": "浙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "宁德市",
                "cityMdCode": 350900,
                "cityAreaMdCode": null,
                "cityPinyin": "NINGDESHI",
                "provinceMdCode": 350000,
                "provinceName": "福建省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "怒江傈僳族自治州",
                "cityMdCode": 533300,
                "cityAreaMdCode": null,
                "cityPinyin": "NUJIANGLISUZUZIZHIZHOU",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "O",
        "list": []
    },
    {
        "first": "P",
        "list": [
            {
                "cityName": "盘锦市",
                "cityMdCode": 211100,
                "cityAreaMdCode": null,
                "cityPinyin": "PANJINSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "攀枝花市",
                "cityMdCode": 510400,
                "cityAreaMdCode": null,
                "cityPinyin": "PANZHIHUASHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "平顶山市",
                "cityMdCode": 410400,
                "cityAreaMdCode": null,
                "cityPinyin": "PINGDINGSHANSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "平凉市",
                "cityMdCode": 620800,
                "cityAreaMdCode": null,
                "cityPinyin": "PINGLIANGSHI",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "萍乡市",
                "cityMdCode": 360300,
                "cityAreaMdCode": null,
                "cityPinyin": "PINGXIANGSHI",
                "provinceMdCode": 360000,
                "provinceName": "江西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "普洱市",
                "cityMdCode": 530800,
                "cityAreaMdCode": null,
                "cityPinyin": "PUERSHI",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "莆田市",
                "cityMdCode": 350300,
                "cityAreaMdCode": null,
                "cityPinyin": "PUTIANSHI",
                "provinceMdCode": 350000,
                "provinceName": "福建省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "濮阳市",
                "cityMdCode": 410900,
                "cityAreaMdCode": null,
                "cityPinyin": "PUYANGSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "Q",
        "list": [
            {
                "cityName": "黔东南苗族侗族自治州",
                "cityMdCode": 522600,
                "cityAreaMdCode": null,
                "cityPinyin": "QIANDONGNANMIAOZUDONGZUZIZHIZHOU",
                "provinceMdCode": 520000,
                "provinceName": "贵州省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "潜江市",
                "cityMdCode": 429005,
                "cityAreaMdCode": null,
                "cityPinyin": "QIANJIANGSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "黔南布依族苗族自治州",
                "cityMdCode": 522700,
                "cityAreaMdCode": null,
                "cityPinyin": "QIANNANBUYIZUMIAOZUZIZHIZHOU",
                "provinceMdCode": 520000,
                "provinceName": "贵州省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "黔西南布依族苗族自治州",
                "cityMdCode": 522300,
                "cityAreaMdCode": null,
                "cityPinyin": "QIANXINANBUYIZUMIAOZUZIZHIZHOU",
                "provinceMdCode": 520000,
                "provinceName": "贵州省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "青岛市",
                "cityMdCode": 370200,
                "cityAreaMdCode": null,
                "cityPinyin": "QINGDAOSHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "庆阳市",
                "cityMdCode": 621000,
                "cityAreaMdCode": null,
                "cityPinyin": "QINGYANGSHI",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "清远市",
                "cityMdCode": 441800,
                "cityAreaMdCode": null,
                "cityPinyin": "QINGYUANSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "秦皇岛市",
                "cityMdCode": 130300,
                "cityAreaMdCode": null,
                "cityPinyin": "QINHUANGDAOSHI",
                "provinceMdCode": 130000,
                "provinceName": "河北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "钦州市",
                "cityMdCode": 450700,
                "cityAreaMdCode": null,
                "cityPinyin": "QINZHOUSHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "琼海市",
                "cityMdCode": 469002,
                "cityAreaMdCode": null,
                "cityPinyin": "QIONGHAISHI",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "琼中黎族苗族自治县",
                "cityMdCode": 469030,
                "cityAreaMdCode": null,
                "cityPinyin": "QIONGZHONGLIZUMIAOZUZIZHIXIAN",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "齐齐哈尔市",
                "cityMdCode": 230200,
                "cityAreaMdCode": null,
                "cityPinyin": "QIQIHAERSHI",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "七台河市",
                "cityMdCode": 230900,
                "cityAreaMdCode": null,
                "cityPinyin": "QITAIHESHI",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "泉州市",
                "cityMdCode": 350500,
                "cityAreaMdCode": null,
                "cityPinyin": "QUANZHOUSHI",
                "provinceMdCode": 350000,
                "provinceName": "福建省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "曲靖市",
                "cityMdCode": 530300,
                "cityAreaMdCode": null,
                "cityPinyin": "QUJINGSHI",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "衢州市",
                "cityMdCode": 330800,
                "cityAreaMdCode": null,
                "cityPinyin": "QUZHOUSHI",
                "provinceMdCode": 330000,
                "provinceName": "浙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "R",
        "list": [
            {
                "cityName": "日喀则市",
                "cityMdCode": 540200,
                "cityAreaMdCode": null,
                "cityPinyin": "RIKAZESHI",
                "provinceMdCode": 540000,
                "provinceName": "西藏自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "日照市",
                "cityMdCode": 371100,
                "cityAreaMdCode": null,
                "cityPinyin": "RIZHAOSHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "S",
        "list": [
            {
                "cityName": "三门峡市",
                "cityMdCode": 411200,
                "cityAreaMdCode": null,
                "cityPinyin": "SANMENXIASHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "三明市",
                "cityMdCode": 350400,
                "cityAreaMdCode": null,
                "cityPinyin": "SANMINGSHI",
                "provinceMdCode": 350000,
                "provinceName": "福建省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "三亚市",
                "cityMdCode": 460200,
                "cityAreaMdCode": null,
                "cityPinyin": "SANYASHI",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "上海市",
                "cityMdCode": 310100,
                "cityAreaMdCode": null,
                "cityPinyin": "SHANGHAISHI",
                "provinceMdCode": 310000,
                "provinceName": "上海市",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "商洛市",
                "cityMdCode": 611000,
                "cityAreaMdCode": null,
                "cityPinyin": "SHANGLUOSHI",
                "provinceMdCode": 610000,
                "provinceName": "陕西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "商丘市",
                "cityMdCode": 411400,
                "cityAreaMdCode": null,
                "cityPinyin": "SHANGQIUSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "上饶市",
                "cityMdCode": 361100,
                "cityAreaMdCode": null,
                "cityPinyin": "SHANGRAOSHI",
                "provinceMdCode": 360000,
                "provinceName": "江西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "山南市",
                "cityMdCode": 540500,
                "cityAreaMdCode": null,
                "cityPinyin": "SHANNANSHI",
                "provinceMdCode": 540000,
                "provinceName": "西藏自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "汕头市",
                "cityMdCode": 440500,
                "cityAreaMdCode": null,
                "cityPinyin": "SHANTOUSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "汕尾市",
                "cityMdCode": 441500,
                "cityAreaMdCode": null,
                "cityPinyin": "SHANWEISHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "韶关市",
                "cityMdCode": 440200,
                "cityAreaMdCode": null,
                "cityPinyin": "SHAOGUANSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "绍兴市",
                "cityMdCode": 330600,
                "cityAreaMdCode": null,
                "cityPinyin": "SHAOXINGSHI",
                "provinceMdCode": 330000,
                "provinceName": "浙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "邵阳市",
                "cityMdCode": 430500,
                "cityAreaMdCode": null,
                "cityPinyin": "SHAOYANGSHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "沈阳市",
                "cityMdCode": 210100,
                "cityAreaMdCode": null,
                "cityPinyin": "SHENYANGSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "深圳市",
                "cityMdCode": 440300,
                "cityAreaMdCode": null,
                "cityPinyin": "SHENZHENSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "石河子市",
                "cityMdCode": 659001,
                "cityAreaMdCode": null,
                "cityPinyin": "SHIHEZISHI",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "石家庄市",
                "cityMdCode": 130100,
                "cityAreaMdCode": null,
                "cityPinyin": "SHIJIAZHUANGSHI",
                "provinceMdCode": 130000,
                "provinceName": "河北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "十堰市",
                "cityMdCode": 420300,
                "cityAreaMdCode": null,
                "cityPinyin": "SHIYANSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "石嘴山市",
                "cityMdCode": 640200,
                "cityAreaMdCode": null,
                "cityPinyin": "SHIZUISHANSHI",
                "provinceMdCode": 640000,
                "provinceName": "宁夏回族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "双鸭山市",
                "cityMdCode": 230500,
                "cityAreaMdCode": null,
                "cityPinyin": "SHUANGYASHANSHI",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "朔州市",
                "cityMdCode": 140600,
                "cityAreaMdCode": null,
                "cityPinyin": "SHUOZHOUSHI",
                "provinceMdCode": 140000,
                "provinceName": "山西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "四平市",
                "cityMdCode": 220300,
                "cityAreaMdCode": null,
                "cityPinyin": "SIPINGSHI",
                "provinceMdCode": 220000,
                "provinceName": "吉林省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "松原市",
                "cityMdCode": 220700,
                "cityAreaMdCode": null,
                "cityPinyin": "SONGYUANSHI",
                "provinceMdCode": 220000,
                "provinceName": "吉林省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "绥化市",
                "cityMdCode": 231200,
                "cityAreaMdCode": null,
                "cityPinyin": "SUIHUASHI",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "遂宁市",
                "cityMdCode": 510900,
                "cityAreaMdCode": null,
                "cityPinyin": "SUININGSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "随州市",
                "cityMdCode": 421300,
                "cityAreaMdCode": null,
                "cityPinyin": "SUIZHOUSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "宿迁市",
                "cityMdCode": 321300,
                "cityAreaMdCode": null,
                "cityPinyin": "SUQIANSHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "苏州市",
                "cityMdCode": 320500,
                "cityAreaMdCode": null,
                "cityPinyin": "SUZHOUSHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "宿州市",
                "cityMdCode": 341300,
                "cityAreaMdCode": null,
                "cityPinyin": "SUZHOUSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "T",
        "list": [
            {
                "cityName": "塔城地区",
                "cityMdCode": 654200,
                "cityAreaMdCode": null,
                "cityPinyin": "TACHENGDIQU",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "泰安市",
                "cityMdCode": 370900,
                "cityAreaMdCode": null,
                "cityPinyin": "TAIANSHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "太原市",
                "cityMdCode": 140100,
                "cityAreaMdCode": null,
                "cityPinyin": "TAIYUANSHI",
                "provinceMdCode": 140000,
                "provinceName": "山西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "泰州市",
                "cityMdCode": 321200,
                "cityAreaMdCode": null,
                "cityPinyin": "TAIZHOUSHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "台州市",
                "cityMdCode": 331000,
                "cityAreaMdCode": null,
                "cityPinyin": "TAIZHOUSHI",
                "provinceMdCode": 330000,
                "provinceName": "浙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "唐山市",
                "cityMdCode": 130200,
                "cityAreaMdCode": null,
                "cityPinyin": "TANGSHANSHI",
                "provinceMdCode": 130000,
                "provinceName": "河北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "天津市",
                "cityMdCode": 120100,
                "cityAreaMdCode": null,
                "cityPinyin": "TIANJINSHI",
                "provinceMdCode": 120000,
                "provinceName": "天津市",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "天门市",
                "cityMdCode": 429006,
                "cityAreaMdCode": null,
                "cityPinyin": "TIANMENSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "天水市",
                "cityMdCode": 620500,
                "cityAreaMdCode": null,
                "cityPinyin": "TIANSHUISHI",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "铁岭市",
                "cityMdCode": 211200,
                "cityAreaMdCode": null,
                "cityPinyin": "TIELINGSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "铁门关市",
                "cityMdCode": 659006,
                "cityAreaMdCode": null,
                "cityPinyin": "TIEMENGUANSHI",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "铜川市",
                "cityMdCode": 610200,
                "cityAreaMdCode": null,
                "cityPinyin": "TONGCHUANSHI",
                "provinceMdCode": 610000,
                "provinceName": "陕西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "通化市",
                "cityMdCode": 220500,
                "cityAreaMdCode": null,
                "cityPinyin": "TONGHUASHI",
                "provinceMdCode": 220000,
                "provinceName": "吉林省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "通辽市",
                "cityMdCode": 150500,
                "cityAreaMdCode": null,
                "cityPinyin": "TONGLIAOSHI",
                "provinceMdCode": 150000,
                "provinceName": "内蒙古自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "铜陵市",
                "cityMdCode": 340700,
                "cityAreaMdCode": null,
                "cityPinyin": "TONGLINGSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "铜仁市",
                "cityMdCode": 520600,
                "cityAreaMdCode": null,
                "cityPinyin": "TONGRENSHI",
                "provinceMdCode": 520000,
                "provinceName": "贵州省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "吐鲁番市",
                "cityMdCode": 650400,
                "cityAreaMdCode": null,
                "cityPinyin": "TULUFANSHI",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "图木舒克市",
                "cityMdCode": 659003,
                "cityAreaMdCode": null,
                "cityPinyin": "TUMUSHUKESHI",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "屯昌县",
                "cityMdCode": 469022,
                "cityAreaMdCode": null,
                "cityPinyin": "TUNCHANGXIAN",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "U",
        "list": []
    },
    {
        "first": "V",
        "list": []
    },
    {
        "first": "W",
        "list": [
            {
                "cityName": "万宁市",
                "cityMdCode": 469006,
                "cityAreaMdCode": null,
                "cityPinyin": "WANNINGSHI",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "潍坊市",
                "cityMdCode": 370700,
                "cityAreaMdCode": null,
                "cityPinyin": "WEIFANGSHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "威海市",
                "cityMdCode": 371000,
                "cityAreaMdCode": null,
                "cityPinyin": "WEIHAISHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "渭南市",
                "cityMdCode": 610500,
                "cityAreaMdCode": null,
                "cityPinyin": "WEINANSHI",
                "provinceMdCode": 610000,
                "provinceName": "陕西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "文昌市",
                "cityMdCode": 469005,
                "cityAreaMdCode": null,
                "cityPinyin": "WENCHANGSHI",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "文山壮族苗族自治州",
                "cityMdCode": 532600,
                "cityAreaMdCode": null,
                "cityPinyin": "WENSHANZHUANGZUMIAOZUZIZHIZHOU",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "温州市",
                "cityMdCode": 330300,
                "cityAreaMdCode": null,
                "cityPinyin": "WENZHOUSHI",
                "provinceMdCode": 330000,
                "provinceName": "浙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "乌海市",
                "cityMdCode": 150300,
                "cityAreaMdCode": null,
                "cityPinyin": "WUHAISHI",
                "provinceMdCode": 150000,
                "provinceName": "内蒙古自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "武汉市",
                "cityMdCode": 420100,
                "cityAreaMdCode": null,
                "cityPinyin": "WUHANSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "芜湖市",
                "cityMdCode": 340200,
                "cityAreaMdCode": null,
                "cityPinyin": "WUHUSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "五家渠市",
                "cityMdCode": 659004,
                "cityAreaMdCode": null,
                "cityPinyin": "WUJIAQUSHI",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "乌兰察布市",
                "cityMdCode": 150900,
                "cityAreaMdCode": null,
                "cityPinyin": "WULANCHABUSHI",
                "provinceMdCode": 150000,
                "provinceName": "内蒙古自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "乌鲁木齐市",
                "cityMdCode": 650100,
                "cityAreaMdCode": null,
                "cityPinyin": "WULUMUQISHI",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "武威市",
                "cityMdCode": 620600,
                "cityAreaMdCode": null,
                "cityPinyin": "WUWEISHI",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "无锡市",
                "cityMdCode": 320200,
                "cityAreaMdCode": null,
                "cityPinyin": "WUXISHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "五指山市",
                "cityMdCode": 469001,
                "cityAreaMdCode": null,
                "cityPinyin": "WUZHISHANSHI",
                "provinceMdCode": 460000,
                "provinceName": "海南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "吴忠市",
                "cityMdCode": 640300,
                "cityAreaMdCode": null,
                "cityPinyin": "WUZHONGSHI",
                "provinceMdCode": 640000,
                "provinceName": "宁夏回族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "梧州市",
                "cityMdCode": 450400,
                "cityAreaMdCode": null,
                "cityPinyin": "WUZHOUSHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "X",
        "list": [
            {
                "cityName": "厦门市",
                "cityMdCode": 350200,
                "cityAreaMdCode": null,
                "cityPinyin": "XIAMENSHI",
                "provinceMdCode": 350000,
                "provinceName": "福建省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "湘潭市",
                "cityMdCode": 430300,
                "cityAreaMdCode": null,
                "cityPinyin": "XIANGTANSHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "湘西土家族苗族自治州",
                "cityMdCode": 433100,
                "cityAreaMdCode": null,
                "cityPinyin": "XIANGXITUJIAZUMIAOZUZIZHIZHOU",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "襄阳市",
                "cityMdCode": 420600,
                "cityAreaMdCode": null,
                "cityPinyin": "XIANGYANGSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "咸宁市",
                "cityMdCode": 421200,
                "cityAreaMdCode": null,
                "cityPinyin": "XIANNINGSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "西安市",
                "cityMdCode": 610100,
                "cityAreaMdCode": null,
                "cityPinyin": "XIANSHI",
                "provinceMdCode": 610000,
                "provinceName": "陕西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "仙桃市",
                "cityMdCode": 429004,
                "cityAreaMdCode": null,
                "cityPinyin": "XIANTAOSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "咸阳市",
                "cityMdCode": 610400,
                "cityAreaMdCode": null,
                "cityPinyin": "XIANYANGSHI",
                "provinceMdCode": 610000,
                "provinceName": "陕西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "孝感市",
                "cityMdCode": 420900,
                "cityAreaMdCode": null,
                "cityPinyin": "XIAOGANSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "锡林郭勒盟",
                "cityMdCode": 152500,
                "cityAreaMdCode": null,
                "cityPinyin": "XILINGUOLEMENG",
                "provinceMdCode": 150000,
                "provinceName": "内蒙古自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "兴安盟",
                "cityMdCode": 152200,
                "cityAreaMdCode": null,
                "cityPinyin": "XINGANMENG",
                "provinceMdCode": 150000,
                "provinceName": "内蒙古自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "邢台市",
                "cityMdCode": 130500,
                "cityAreaMdCode": null,
                "cityPinyin": "XINGTAISHI",
                "provinceMdCode": 130000,
                "provinceName": "河北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "西宁市",
                "cityMdCode": 630100,
                "cityAreaMdCode": null,
                "cityPinyin": "XININGSHI",
                "provinceMdCode": 630000,
                "provinceName": "青海省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "新乡市",
                "cityMdCode": 410700,
                "cityAreaMdCode": null,
                "cityPinyin": "XINXIANGSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "信阳市",
                "cityMdCode": 411500,
                "cityAreaMdCode": null,
                "cityPinyin": "XINYANGSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "新余市",
                "cityMdCode": 360500,
                "cityAreaMdCode": null,
                "cityPinyin": "XINYUSHI",
                "provinceMdCode": 360000,
                "provinceName": "江西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "忻州市",
                "cityMdCode": 140900,
                "cityAreaMdCode": null,
                "cityPinyin": "XINZHOUSHI",
                "provinceMdCode": 140000,
                "provinceName": "山西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "西双版纳傣族自治州",
                "cityMdCode": 532800,
                "cityAreaMdCode": null,
                "cityPinyin": "XISHUANGBANNADAIZUZIZHIZHOU",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "宣城市",
                "cityMdCode": 341800,
                "cityAreaMdCode": null,
                "cityPinyin": "XUANCHENGSHI",
                "provinceMdCode": 340000,
                "provinceName": "安徽省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "许昌市",
                "cityMdCode": 411000,
                "cityAreaMdCode": null,
                "cityPinyin": "XUCHANGSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "徐州市",
                "cityMdCode": 320300,
                "cityAreaMdCode": null,
                "cityPinyin": "XUZHOUSHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "Y",
        "list": [
            {
                "cityName": "雅安市",
                "cityMdCode": 511800,
                "cityAreaMdCode": null,
                "cityPinyin": "YAANSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "延安市",
                "cityMdCode": 610600,
                "cityAreaMdCode": null,
                "cityPinyin": "YANANSHI",
                "provinceMdCode": 610000,
                "provinceName": "陕西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "延边朝鲜族自治州",
                "cityMdCode": 222400,
                "cityAreaMdCode": null,
                "cityPinyin": "YANBIANCHAOXIANZUZIZHIZHOU",
                "provinceMdCode": 220000,
                "provinceName": "吉林省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "盐城市",
                "cityMdCode": 320900,
                "cityAreaMdCode": null,
                "cityPinyin": "YANCHENGSHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "阳江市",
                "cityMdCode": 441700,
                "cityAreaMdCode": null,
                "cityPinyin": "YANGJIANGSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "阳泉市",
                "cityMdCode": 140300,
                "cityAreaMdCode": null,
                "cityPinyin": "YANGQUANSHI",
                "provinceMdCode": 140000,
                "provinceName": "山西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "扬州市",
                "cityMdCode": 321000,
                "cityAreaMdCode": null,
                "cityPinyin": "YANGZHOUSHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "烟台市",
                "cityMdCode": 370600,
                "cityAreaMdCode": null,
                "cityPinyin": "YANTAISHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "宜宾市",
                "cityMdCode": 511500,
                "cityAreaMdCode": null,
                "cityPinyin": "YIBINSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "宜昌市",
                "cityMdCode": 420500,
                "cityAreaMdCode": null,
                "cityPinyin": "YICHANGSHI",
                "provinceMdCode": 420000,
                "provinceName": "湖北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "宜春市",
                "cityMdCode": 360900,
                "cityAreaMdCode": null,
                "cityPinyin": "YICHUNSHI",
                "provinceMdCode": 360000,
                "provinceName": "江西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "伊春市",
                "cityMdCode": 230700,
                "cityAreaMdCode": null,
                "cityPinyin": "YICHUNSHI",
                "provinceMdCode": 230000,
                "provinceName": "黑龙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "伊犁哈萨克自治州",
                "cityMdCode": 654000,
                "cityAreaMdCode": null,
                "cityPinyin": "YILIHASAKEZIZHIZHOU",
                "provinceMdCode": 650000,
                "provinceName": "新疆维吾尔自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "银川市",
                "cityMdCode": 640100,
                "cityAreaMdCode": null,
                "cityPinyin": "YINCHUANSHI",
                "provinceMdCode": 640000,
                "provinceName": "宁夏回族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "营口市",
                "cityMdCode": 210800,
                "cityAreaMdCode": null,
                "cityPinyin": "YINGKOUSHI",
                "provinceMdCode": 210000,
                "provinceName": "辽宁省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "鹰潭市",
                "cityMdCode": 360600,
                "cityAreaMdCode": null,
                "cityPinyin": "YINGTANSHI",
                "provinceMdCode": 360000,
                "provinceName": "江西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "益阳市",
                "cityMdCode": 430900,
                "cityAreaMdCode": null,
                "cityPinyin": "YIYANGSHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "永州市",
                "cityMdCode": 431100,
                "cityAreaMdCode": null,
                "cityPinyin": "YONGZHOUSHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "岳阳市",
                "cityMdCode": 430600,
                "cityAreaMdCode": null,
                "cityPinyin": "YUEYANGSHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "玉林市",
                "cityMdCode": 450900,
                "cityAreaMdCode": null,
                "cityPinyin": "YULINSHI",
                "provinceMdCode": 450000,
                "provinceName": "广西壮族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "榆林市",
                "cityMdCode": 610800,
                "cityAreaMdCode": null,
                "cityPinyin": "YULINSHI",
                "provinceMdCode": 610000,
                "provinceName": "陕西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "运城市",
                "cityMdCode": 140800,
                "cityAreaMdCode": null,
                "cityPinyin": "YUNCHENGSHI",
                "provinceMdCode": 140000,
                "provinceName": "山西省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "云浮市",
                "cityMdCode": 445300,
                "cityAreaMdCode": null,
                "cityPinyin": "YUNFUSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "玉溪市",
                "cityMdCode": 530400,
                "cityAreaMdCode": null,
                "cityPinyin": "YUXISHI",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    },
    {
        "first": "Z",
        "list": [
            {
                "cityName": "枣庄市",
                "cityMdCode": 370400,
                "cityAreaMdCode": null,
                "cityPinyin": "ZAOZHUANGSHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "张家界市",
                "cityMdCode": 430800,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHANGJIAJIESHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "张家口市",
                "cityMdCode": 130700,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHANGJIAKOUSHI",
                "provinceMdCode": 130000,
                "provinceName": "河北省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "张掖市",
                "cityMdCode": 620700,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHANGYESHI",
                "provinceMdCode": 620000,
                "provinceName": "甘肃省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "漳州市",
                "cityMdCode": 350600,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHANGZHOUSHI",
                "provinceMdCode": 350000,
                "provinceName": "福建省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "湛江市",
                "cityMdCode": 440800,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHANJIANGSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "肇庆市",
                "cityMdCode": 441200,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHAOQINGSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "昭通市",
                "cityMdCode": 530600,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHAOTONGSHI",
                "provinceMdCode": 530000,
                "provinceName": "云南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "郑州市",
                "cityMdCode": 410100,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHENGZHOUSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "镇江市",
                "cityMdCode": 321100,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHENJIANGSHI",
                "provinceMdCode": 320000,
                "provinceName": "江苏省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "中山市",
                "cityMdCode": 442000,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHONGSHANSHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "中卫市",
                "cityMdCode": 640500,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHONGWEISHI",
                "provinceMdCode": 640000,
                "provinceName": "宁夏回族自治区",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "周口市",
                "cityMdCode": 411600,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHOUKOUSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "舟山市",
                "cityMdCode": 330900,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHOUSHANSHI",
                "provinceMdCode": 330000,
                "provinceName": "浙江省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "珠海市",
                "cityMdCode": 440400,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHUHAISHI",
                "provinceMdCode": 440000,
                "provinceName": "广东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "驻马店市",
                "cityMdCode": 411700,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHUMADIANSHI",
                "provinceMdCode": 410000,
                "provinceName": "河南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "株洲市",
                "cityMdCode": 430200,
                "cityAreaMdCode": null,
                "cityPinyin": "ZHUZHOUSHI",
                "provinceMdCode": 430000,
                "provinceName": "湖南省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "淄博市",
                "cityMdCode": 370300,
                "cityAreaMdCode": null,
                "cityPinyin": "ZIBOSHI",
                "provinceMdCode": 370000,
                "provinceName": "山东省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "自贡市",
                "cityMdCode": 510300,
                "cityAreaMdCode": null,
                "cityPinyin": "ZIGONGSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "资阳市",
                "cityMdCode": 512000,
                "cityAreaMdCode": null,
                "cityPinyin": "ZIYANGSHI",
                "provinceMdCode": 510000,
                "provinceName": "四川省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            },
            {
                "cityName": "遵义市",
                "cityMdCode": 520300,
                "cityAreaMdCode": null,
                "cityPinyin": "ZUNYISHI",
                "provinceMdCode": 520000,
                "provinceName": "贵州省",
                "county": null,
                "parentMdCode": null,
                "postCode": null,
                "level": 2
            }
        ]
    }
]

export const firstList = [
    {
        first: 'A',
    },
    {
        first: 'B',
    },
    {
        first: 'C',

    },
    {
        first: 'D',

    },
    {
        first: 'E',

    },
    {
        first: 'F',

    },
    {
        first: 'G',

    },
    {
        first: 'H',

    },
    {
        first: 'I',

    },
    {
        first: 'J',

    },
    {
        first: 'K',

    }, {
        first: 'L',

    }, {
        first: 'M',

    }, {
        first: 'N',

    }, {
        first: 'O',

    }, {
        first: 'P',

    }, {
        first: 'Q',

    }, {
        first: 'R',

    }, {
        first: 'S',

    }, {
        first: 'T',

    }, {
        first: 'U',

    }, {
        first: 'V',

    }
    , {
        first: 'W',

    },
    {
        first: 'X',

    },
    {
        first: 'Y',

    },
    {
        first: 'Z',

    },
];

let test = {
    "onlyForExchange": false,
    "id": "1657780165779537920",
    "orderNo": "1657780165779537920",
    "memberId": 47349523905,
    "mobile": "13143615954",
    "shopId": 20300008621,
    "latitude": 22.62057,
    "longitude": 107.975755,
    "origin": 2,
    "type": 1,
    "actualType": null,
    "finishType": 1,
    "status": 50,
    "productStatus": 40,
    "expressStatus": null,
    "expressMode": null,
    "isYouzanMigrate": 2,
    "invoiceStatus": 10,
    "refundStatus": 1,
    "createTime": "2025-01-09 10:09:12",
    "refundTime": "",
    "modifyTime": "2025-01-09 10:12:42",
    "cancelTime": "",
    "paymentDeadlineTime": "2025-01-09 10:14:12",
    "deadLineSeconds": 0,
    "payTime": "2025-01-09 10:09:45",
    "finishTime": 1736388762000,
    "channel": 1,
    "brandNo": "20200000006",
    "shopOperationMode": null,
    "cooperationMode": 1,
    "saleNature": 10,
    "cityCode": "451400",
    "isEvaluate": 0,
    "allowEvaluate": 1,
    "allowRefund": 0,
    "dispatchShowConfig": "暂无物流信息",
    "expressCount": null,
    "takeType": 1,
    "takeTypeStr": "自取",
    "expectTakeBeginTime": "2025-01-09 10:12:15",
    "expectTakeEndTime": "",
    "distributorExpectTime": "",
    "preOrderId": null,
    "orderFinanceDetail": {
        "id": 1657780165779538000,
        "totalOriginMoney": 32,
        "totalProductMoney": 32,
        "totalPayableMoney": 1,
        "totalRefundMoney": 0,
        "actuallyMoney": 1,
        "orderActuallyPayMoney": 1,
        "invoiceMoney": 1,
        "invoicedMoney": 0,
        "mayRefundMoney": 1,
        "totalDiscountMoney": 31,
        "priceDiscountMoney": 0,
        "couponDiscountMoney": 31,
        "voucherDiscountMoney": 0,
        "awardDiscountMoney": null,
        "specialDiscountMoney": 0,
        "totalUnspecialOfferDiscountMoney": 0,
        "totalDeliveryMoney": 0,
        "deliveryPayMoney": 0,
        "deliveryDiscountType": 0,
        "specialActivityFinanceList": []
    },
    "orderExtendDetail": {
        "id": 1657780165779538000,
        "shopId": 20300008621,
        "shopName": "广西自然职院店",
        "shopCity": "崇左市",
        "shopAddress": "扶绥县空港扶绥经济区空港大道东29号1食堂东北1商铺",
        "shopPhone": "18378166297",
        "memberRemark": "",
        "takeNo": "A465",
        "memberSex": 1,
        "shopSequenceNumber": "JD2023112500018",
        "memberNickName": "13143615954",
        "takeNoStatus": 1,
        "shopMdCode": "20300008621",
        "memberNo": "47349523905",
        "takeAddress": "",
        "takePoiAddress": "null",
        "takeHumPhone": null,
        "takeHumName": null,
        "takeHumSex": null,
        "isFavorite": false
    },
    "orderPayDetail": {
        "id": 1657780165779538000,
        "status": 2,
        "payNo": null,
        "payMode": 1,
        "payFrom": 1,
        "payFormName": "支付宝",
        "payMoney": 1
    },
    "orderExpressDetail": null,
    "orderCancelDetail": {"id": null, "cancelUserType": null, "cancelReason": null, "cancelReasonType": null},
    "orderProducts": [{
        "id": 1657780165779538000,
        "skuCode": "SP2503-00005",
        "skuName": "云顶慕斯欧培拉拿铁-大杯16oz-热-半糖",
        "skuNameShow": "大杯16oz/热/半糖",
        "productId": -1,
        "productCode": "SP2503",
        "productName": "云顶慕斯欧培拉拿铁",
        "productNameShow": "云顶慕斯欧培拉拿铁",
        "productMakeType": 1,
        "productImgUrl": "https://cdn-product-prod.yummy.tech:443/productmanager-admin/2024/12/e77d804bff1f4aea8ef043a39f838c9e_云顶慕斯欧培拉拿铁去冰.jpg",
        "originPrice": 32,
        "afterDiscountMoney": 32,
        "quantity": 1,
        "payableMoney": 1,
        "payMoney": 1,
        "couponDiscountMoney": 31,
        "voucherDiscountMoney": 0,
        "refundMoney": null,
        "refundStatus": 1,
        "returnFoodStatus": 1,
        "preferenceType": "4",
        "preferenceTypeDesc": "优惠券",
        "activityType": null,
        "specialArea": 1,
        "specialTag": null,
        "packageTitle": null,
        "packageNo": null,
        "packageImg": null,
        "packageId": null,
        "packageIndex": null,
        "packageNum": null,
        "packageFloor": null,
        "packageOriginPrice": null,
        "packagePayMoney": null,
        "spuType": 1,
        "packageSkuName": "大杯16oz/热/半糖",
        "packageProductDetailList": null,
        "brandCooperatorMdCode": null,
        "brandGoodsOrderShowIconUrl": null,
        "brandGoodsOrderShowTip": null,
        "groupTitle": null,
        "groupTitleTip": null
    }],
    "productQuantity": 1,
    "hiddenCancel": 1,
    "hiddenExpressPhone": 1,
    "systemCurrentTime": "2025-01-09 23:04:19",
    "orderStatusStrMsg": {
        "status": "HISTORY_COMPLETED",
        "statusStr": "已完成",
        "appTabStatus": 2,
        "orderDetailCopywriting": "感谢您对Cotti Coffee的支持，欢迎再次光临",
        "orderDetailCopyBakwriting": null,
        "orderDetailCancelContext": null,
        "showProcessBar": true,
        "takeNoLabel": "取餐码"
    },
    "canteenPaySerialNumber": null,
    "canteenCardName": null,
    "canteenCardHiddenCancelContext": null,
    "takeNoEmptyContext": "刷卡后生成",
    "cancleOrderConfigDTO": {
        "title": "温馨提醒",
        "content": "订单取消后，再次下单若非外卖「首单外卖免配送费权益」将失效，是否确认取消？",
        "description": [{"head": "新人首单免配送费权益", "text": "Cotti 会员首次下单并且订单为外卖配送时，可享受「首单外卖免配送费权益」。"}]
    },
    "specialOrderTag": "限时特价",
    "unspecialOrderTag": null,
    "labelStr": "App",
    "takeNoShowTimeHour": 24,
    "customerDisplay": true,
    "allowInvoicing": 1,
    "refundGoodsAmount": 0,
    "authorizeNoticePromptContext": "预估时长仅供参考，制作完成后将第一时间为您推送取餐通知",
    "existThirdBrandGoods": false,
    "showReOrder": true
}